import React from 'react'
import '../../_metronic/partials/MapComponents/MapDetail.css'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../_metronic/helpers'
import {
  ChartsWidget1,
  TablesWidget1,
  ListsWidget5,
  TablesWidget5,
} from '../../_metronic/partials/widgets'
import {useParams} from 'react-router-dom'
import tutorial from '../../_metronic/assets/images/tutorial.jpg'
import upload from '../../_metronic/assets/images/upload.png'

const UserBeta = () => {
  const {details} = useParams()
  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>User Beta 1 Page</h3>
          </div>

          <Link to='/userbeta1/edit' className='btn btn-primary align-self-center'>
            {/* Link değişecek */}
            Edit
          </Link>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>Emre</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Surname</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>Soyak</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Nickname</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>AtlasAdminEmre</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Password</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>******</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Role</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Admin</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Title</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>CPO</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Company Name</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Atlas Space</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Skills</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Html,Css,Js,Php</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User 3D avatar</label>

            <div className='col-lg-8 map_cards'>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Profile Photo</label>

            <div className='col-lg-8 map_cards'>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Avatar Pic</label>

            <div className='col-lg-8 map_cards'>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Avatar Profile Pic</label>

            <div className='col-lg-8 map_cards'>
              <span className='map_item'>
                <img className='map_img' src={tutorial} alt='' />
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User FriendList</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Burcin, Yücel, Hanife</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Ban List</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Artun, Ümit</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Inbox</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Messages id</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User About me Content</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <p className='fw-bolder fs-6 me-2'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae iste dolores
                quis cumque iusto facere doloribus ad laudantium, ipsa odio voluptatibus eum, fugiat
                quas perferendis!
              </p>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Profile Share Link Url</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>http://atlas.space/people/EmreSoyak</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>User Team</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Atlas Space C Team</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserBeta
